import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGiroCards: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconGiroCards"><Path d="M17.25 8.75H18.25C19.9069 8.75 21.25 10.0931 21.25 11.75V16.25C21.25 17.9069 19.9069 19.25 18.25 19.25H9.75C8.09315 19.25 6.75 17.9069 6.75 16.25V15.25M6.75 8.75H8.25M5.75 15.25H14.25C15.9069 15.25 17.25 13.9069 17.25 12.25V7.75C17.25 6.09315 15.9069 4.75 14.25 4.75H5.75C4.09315 4.75 2.75 6.09315 2.75 7.75V12.25C2.75 13.9069 4.09315 15.25 5.75 15.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconGiroCards;
